/**
 * Rows for the staff view of account deletion requests.
 *
 * A request is due one month after the customer asked (UK GDPR). The page shows
 * the due date and how many days are left, so nothing slips past it.
 */

const DAY_MS = 24 * 60 * 60 * 1000

export const STATUS_LABELS = {
  awaiting_confirmation: 'Waiting for the customer to confirm',
  confirmed: 'Confirmed, ready to complete',
}

export const BLOCKER_LABELS = {
  quote: 'an open quote',
  payout: 'a payout in progress',
}

/** Whole days from `now` to `dueAt`; negative once overdue. */
export function daysLeft(dueAt, now = new Date()) {
  return Math.ceil((new Date(dueAt).getTime() - now.getTime()) / DAY_MS)
}

/** "3 days left", "Due today", "2 days overdue". */
export function dueLabel(dueAt, now = new Date()) {
  const days = daysLeft(dueAt, now)
  if (days > 1) return `${days} days left`
  if (days === 1) return '1 day left'
  if (days === 0) return 'Due today'
  return days === -1 ? '1 day overdue' : `${-days} days overdue`
}

/** What stops a request being completed now, in words, or null. */
export function blockedReason(row) {
  if (row.status !== 'confirmed') return STATUS_LABELS[row.status] || row.status
  if (row.blockers?.length) {
    return `The customer has ${row.blockers.map(b => BLOCKER_LABELS[b] || b).join(' and ')}`
  }
  return null
}

export function displayName(row) {
  return [row.first_name, row.last_name].filter(Boolean).join(' ') || 'No name on file'
}
